"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var mediaUpload_1 = require("../../youwell-common/mediaUpload");
var errorUtils_1 = require("../../youwell-common/errorUtils");
var constants_1 = require("../../youwell-common/constants");
var store_1 = require("../../app/store");
var translate_1 = __importDefault(require("../../app/localization/translate"));
var icons_1 = require("../../youwell-common/icons");
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    root: {},
    input: {
        display: 'none',
    },
    error: {
        marginTop: theme.spacing(1),
    },
    selectedFile: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: theme.spacing(1),
    },
    attachedCaption: {
        marginRight: theme.spacing(1),
    },
    clearIcon: {
        marginLeft: theme.spacing(1),
        height: 40,
        width: 40,
    },
}); }, { name: 'FileUpload' });
var getErrorMessage = function (errorMessageOrCode) {
    var errorCode = Number(errorMessageOrCode);
    if (errorCode === 1110) {
        return 'fileUpload.invalidFiletypes';
    }
    if (Number.isNaN(errorCode)) {
        return 'uploadFailed';
    }
    return "errors.".concat(errorMessageOrCode);
};
var FileUpload = function (_a) {
    var className = _a.className, onSelected = _a.onSelected, filetypes = _a.filetypes;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var appConfig = (0, store_1.useYouwellSelector)(function (state) { return state.pageSettings.appConfig; });
    var _b = React.useState(false), isUploading = _b[0], setIsUploading = _b[1];
    var _c = React.useState(''), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(''), fileName = _d[0], setFileName = _d[1];
    var clearFile = function () {
        onSelected(null);
        setFileName('');
    };
    var handleFileUpload = function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            setIsUploading(true);
            (0, mediaUpload_1.uploadPatientFile)(file)
                .then(function (data) {
                onSelected(data);
                setFileName(data.name);
                setIsUploading(false);
            })
                .catch(function (error) {
                (0, errorUtils_1.sendError)({ sender: 'FileUpload', error: 'Failed to upload file', info: error && error.toString() });
                setIsUploading(false);
                setErrorMessage(getErrorMessage(error.message));
            });
        }
        else {
            clearFile();
        }
    };
    // const url = fileId ? `${apiUrls.baseUrl}/${apiUrls.app.media}/${fileId}` : '';
    var id = "file_upload_".concat(Date.now());
    var acceptedTypes = filetypes === null || filetypes === void 0 ? void 0 : filetypes.map(mediaUpload_1.getAccept).join(',');
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.root, className) }, fileName ? (React.createElement("div", { className: classes.selectedFile },
        React.createElement(core_1.Typography, { className: classes.attachedCaption }, "".concat(translate('fileUpload.attached'), ": ")),
        React.createElement(core_1.Typography, { color: "textSecondary" }, fileName),
        React.createElement(core_1.IconButton, { onClick: clearFile, className: classes.clearIcon, title: translate('fileUpload.removeFile') },
            React.createElement(icons_1.ClearIcon, null)))) : (React.createElement(React.Fragment, null,
        React.createElement("input", { accept: acceptedTypes, className: classes.input, onChange: handleFileUpload, id: id, type: "file" }),
        React.createElement("label", { htmlFor: id },
            React.createElement(core_1.Button, { color: "primary", component: "span", disabled: isUploading }, isUploading ? (React.createElement(core_1.CircularProgress, { size: 20 })) : translate('fileUpload.attachFile'))),
        errorMessage && (React.createElement("div", { className: classes.error },
            React.createElement(core_1.Typography, { color: "error" }, translate(errorMessage, { maxUploadSizeMB: appConfig.maxUploadSizeMB }))))))));
};
FileUpload.defaultProps = {
    className: null,
    filetypes: [constants_1.fileTypes.image, constants_1.fileTypes.audio, constants_1.fileTypes.document],
};
exports.default = FileUpload;
